import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-contrato-marco',
  templateUrl: './contrato-marco.component.html',
  styleUrls: ['./contrato-marco.component.scss']
})
export class ContratoMarcoComponent  {

  constructor(private loginService:LoginService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
 }
}
